import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input } from '../../../Elements';
import NumberFormat from 'react-number-format';

export default class DownPayment extends React.Component {
  static propTypes = {
    currencyFieldChange: PropTypes.func.isRequired,
    DateInput: PropTypes.func,
    dateFieldChange: PropTypes.func.isRequired,
    localInvoice: PropTypes.object.isRequired,
    numberFieldChange: PropTypes.func.isRequired,
    submitted: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.onDownPaymentDistributionChange = this.onDownPaymentDistributionChange.bind(
      this
    );
  }

  onDownPaymentDistributionChange(e) {
    this.fieldChange('down_payment_distribution_type', e.target.value);
  }

  render() {
    const {
      currencyFieldChange,
      dateFieldChange,
      localInvoice,
      numberFieldChange,
      submitted,
      DateInput
    } = this.props;

    return (
      <div>
        <div
          style={{
            display: 'inline-block',
            marginTop: '1.75em',
            marginRight: '0.5em'
          }}
        >
          A down payment of
        </div>
        {localInvoice.down_payment_distribution_type === 'FIXED' &&
          <Input
            name='down_payment_cents'
            type='currency'
            placeholder='$500.00'
            value={
              localInvoice.down_payment_cents
                ? (localInvoice.down_payment_cents || 0) / 100
                : ''
            }
            onChange={currencyFieldChange}
            submitted={submitted}
            inline='last'
            width='80px'
            label=''
            style={{
              marginTop: '1.25em'
            }}
          >
            <NumberFormat
              thousandSeparator
              prefix={'$'}
              decimalScale={2}
              fixedDecimalScale
            />
          </Input>}
        {localInvoice.down_payment_distribution_type === 'PERCENT' &&
          <Input
            name='down_payment_percent'
            placeholder='50%'
            type='currency'
            value={localInvoice.down_payment_percent || ''}
            onChange={numberFieldChange}
            submitted={submitted}
            required
            inline='last'
            width='50px'
            label=''
            style={{
              marginLeft: '1em',
              marginTop: '1.25em'
            }}
            validationError='Required'
          >
            <NumberFormat
              suffix={'%'}
              allowNegative={false}
              isAllowed={values =>
                values.floatValue >= 0 && values.floatValue <= 100}
            />
          </Input>}
        {/* <Select
          name='down_payment_distribution_type'
          value={localInvoice.down_payment_distribution_type}
          type='select'
          onChange={this.onDownPaymentDistributionChange}
          submitted={submitted}
          placeholder='Type...'
          options={[
            { text: 'flat', value: 'FIXED' },
            { text: 'percent', value: 'PERCENT' }
          ]}
          style={{
            marginTop: '0.675em',
            marginLeft: '1em',
            paddingLeft: 0
          }}
          inline
          required
          validationError='Required'
        /> */}
        <div
          style={{
            display: 'inline-block',
            marginTop: '1.75em',
            marginLeft: '0.5em',
            marginRight: '0.5em'
          }}
        >
          is due on
        </div>
        <DateInput
          dateOnly
          value={localInvoice.down_payment_due_at || ''}
          onChange={dateFieldChange}
          name='down_payment_due_at'
          label=''
          style={{
            marginTop: '1.25em'
          }}
          placeholder='Date'
          datePlaceholder='Date (optional)'
          inline
          submitted={submitted}
          viewer={null}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/PaymentPlan/DownPayment.js